(function () {
  'use strict';

  var STORAGE_KEY = 'hvac_nl_dismissed';
  var DELAY_MS = 4000;

  function init() {
    console.log('[HVAC Popup] Script loaded');

    var overlay = document.getElementById('hvac-nl-overlay');
    if (!overlay) {
      console.log('[HVAC Popup] ERROR: overlay element not found');
      return;
    }
    console.log('[HVAC Popup] Overlay found');

    var forceShow = window.location.search.indexOf('newsletter=preview') !== -1;
    var alreadyDismissed = localStorage.getItem(STORAGE_KEY);

    console.log('[HVAC Popup] forceShow:', forceShow, '| alreadyDismissed:', alreadyDismissed);

    if (!forceShow && alreadyDismissed) {
      console.log('[HVAC Popup] Skipping — already dismissed. Run localStorage.removeItem("' + STORAGE_KEY + '") in console to reset.');
      return;
    }

    var delay = forceShow ? 500 : DELAY_MS;
    console.log('[HVAC Popup] Will show in', delay, 'ms');

    setTimeout(function () {
      console.log('[HVAC Popup] Showing popup');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }, delay);

    function close() {
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      if (!forceShow) localStorage.setItem(STORAGE_KEY, '1');
    }

    overlay.querySelector('.hvac-nl-close').addEventListener('click', close);
    overlay.querySelector('.hvac-nl-dismiss').addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    var form = document.getElementById('hvac-nl-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = document.getElementById('hvac-nl-email').value.trim();
        if (!email) return;

        var body = 'form_type=customer'
          + '&utf8=%E2%9C%93'
          + '&contact%5Btags%5D=newsletter'
          + '&contact%5Bemail%5D=' + encodeURIComponent(email);

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: body
        }).finally(function () {
          form.style.display = 'none';
          var success = overlay.querySelector('.hvac-nl-success');
          if (success) success.style.display = 'block';
          if (!forceShow) localStorage.setItem(STORAGE_KEY, '1');
          setTimeout(close, 2400);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
